$(document).ready(function() {

  // BE CAREFUL TO NOT USE BEEMELF IF YOU'RE ON THE GOAL PAGE
  // WE DON'T HAVE IT LOADED


  //if not on gmail goal page or on elf, abandon ship!
  if ($("#gmail-labels").length !== 0 ) { // on gmail goal page
    var GOALPAGE = true;
  } else if ($("#elf-gmail-labels").length !== 0) { // on elf
    var GOALPAGE = false;
  } else {
    return;
  }

  function updateWithGmailLabels() {
    $("#gmail-labels").prop("disabled", true);
    $("#elf-gmail-labels").prop("disabled", true);

    var baseURL = "/gmail_user_info.json";
    $.getJSON(baseURL, function(data){

      $("#checkingGmailService").hide();

      if (data["error"] && GOALPAGE) {
        beetils.showFlash("error", "Error getting Gmail labels: " + data["error"]);
      } else if (data["error"] && !GOALPAGE) {
        $("#gmailServiceOK").hide(); //elf gmail step
        $("#gmailServiceNotOK").show(); //elf gmail step
      } else {
        if (!GOALPAGE) { //we're on elf
          $("#gmailServiceOK").show(); //elf gmail step
          $("#gmailServiceNotOK").hide(); //elf gmail step
        }

        //If we are on the settings page, the id "gmail-label" has a data attribute
        //that shows what we have set in our goal settings

        var set_gmail_label = $("#gmail-label").data("ii-gmailzero-label");

        //If we are on the elf page or gmail goal page,
        //the id #gmail-labels exists, and needs to be filled with the labels

        data["labels"].forEach(function(e, i) {
          var entry = "<option value='" + e + "'";
          if (e === set_gmail_label)
          {
            entry += " selected";
          }
          entry += ">" + e + "</option>"
          $("#gmail-labels").append(entry);
          $("#elf-gmail-labels").append(entry);
        });
        $("#gmail-labels").prop("disabled", false);
        $("#elf-gmail-labels").prop("disabled", false);
      }
    });
  }

  // we know we're either on elf or on a goal page.
  // but we want only to run update if it's elf, or our own goal page. 
  // (i.e., not when it's somebody else's gmail goal page)
  if (GOALPAGE && $(".goal-panel").data("username") === beemApi.currentUsername ) {
    updateWithGmailLabels();
  }

  //only on elf
  if (!GOALPAGE) {
    $("#checkingGmailService").show();
    $("#gmailServiceOK").hide();
    $("#gmailServiceNotOK").hide();
    updateWithGmailLabels();

    beemElf.gmail = {};

    beemElf.gmail.validateForm = function() {
      // if there's no target inbox value given, complain
      var target = $("#gmail .stepper-value").val()
      var targerr = beemElf.targetError("inboxer", target)
      if (targerr) {
        beetils.showFlash("error", targerr);
        return false;
      }
      if ($("#gmail .leeway-control-group input").prop("checked")) {
        if (beemElf.showBufferDaysError("inboxer", $("#gmail .buffer-days").val())) {
          return false;
        }
      }
      return true;
    }

    beemElf.gmail.saveForm = function() {
      beemElf.ls.setGoalType("inboxer");
      beemElf.ls.setGoalGUnits("messages");
      beemElf.ls.setGoalRUnits("d");
      beemElf.ls.setGoalVal($("#gmail .stepper-value").val());
      beemElf.ls.saveBufferDaysFromForm("#gmail");
      beemElf.ls.setGoalii({
        name: "gmailzero",
        gmailzero_label: $("#elf-gmail-labels").val(),
        gmailzero_readstate: $("select[name='ii[gmailzero_readstate]']").val()
      });
    }

    $(".gmail-continue").click(function(e) {
      e.preventDefault()
      beetils.hideFlash()
      if (!beemElf.gmail.validateForm()) {
        return false;
      }
      $(this).prop("disabled", true);
      // form has valid inputs. Now fetch initval from autod/gmail_info
      beetils.showFlash("notice", "Fetching your label count from Gmail", true)
      $.getJSON("/gmail_label_info", {labelname: $("#elf-gmail-labels").val()},
          function(data){
            if (data.error) {
              $(".gmail-continue").prop("disabled",false)
            } else {
              beemElf.gmail.saveForm()
              var state = beemElf.ls.goalii().gmailzero_readstate
              var msgs = null
              if (state === "all") {
                msgs = data.threadsTotal
              }
              else if (state === "read") {
                msgs = data.threadsTotal - data.threadsUnread
              }
              else if (state === "unread") {
                msgs = data.threadsUnread
              }
              else {
                // ERROR! invalid readstate
              }
              console.log("MESSAGES!", msgs)
              beemElf.ls.setGoalInitVal(msgs)
              beemElf.showStep("name")
            }
          })
          .fail(function(data){
            $(".gmail-continue").prop("disabled",false)
          })
    });

    //Update the elf text based on form selections
    $("#ii_gmailzero_readstate").change(function() {
      const selection = $(this).children("option:selected").val();
      var units = "messages";
      if (selection !== "all")
      {
        units = selection + " " + units;
      }

      $("#gmail-message-stepper-row .units").val(units);
    });

    $("#elf-gmail-labels").change(function() {
      const selection = $(this).children("option:selected").val();
      var headline = "";
      if (selection === "INBOX")
      {
        headline_text = "inbox*";
      } else {
        headline_text = "gmail label* " + selection;
      }

      $("#gmail-headline-label").text(headline_text);
    });

  }
});
